module.exports = __webpack_public_path__ + "static/media/L-9.869d31d6.svg";